import styled from 'styled-components'

export const StyledSkeleton = styled.div<{$width?: number | string}>`
    display: flex;
    width: ${props => (props.$width ? `${props.$width}px` : '100%')};
    svg {
        flex-shrink: initial;
    }
`
